import { UICorePlugin } from "../../../../lib/Plugin";
import { hookVWVHConvert } from './VHVWConvert';
/** ui-core内置的全局样式转换插件*/
export class StyleConvertPlugin extends UICorePlugin {
  install(uc) {
    hookVWVHConvert(uc);
  }
}